import React from "react";
import styles from "./index.module.scss";
import Modal from "../../../../../shared/ui/Modal";
import { Button } from "../../../../../shared/ui/Button";
import { IOffer } from "../../../../../shared/store/payment/types";

interface IPhotoDataModal {
  isOpen: boolean;
  onClose: () => void;
  offer: IOffer;
}

// Модалка «Данные для фото карты»: показывает данные сделки для фона фото
// (без номера карты получателя) + обязательное антифрод-подтверждение.
export const PhotoDataModal: React.FC<IPhotoDataModal> = ({
  isOpen,
  onClose,
  offer,
}) => {
  const onUpload = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} setStatus={onClose} modalClassName={styles.modal}>
      <div className={styles.title}>Данные для фото карты</div>
      <p className={styles.lead}>
        Оставьте это окно открытым на экране и сделайте фото карты на фоне данных
        ниже.
      </p>

      {/* Прокручиваемая справочная часть. Чекбокс и кнопки вынесены в footer
          ниже, чтобы обязательное подтверждение не уезжало под скролл. */}
      <div className={styles.scroll_body}>
        <div className={styles.photo_bg}>
          <div className={styles.photo_bg_title}>Информация для фона фото</div>
          <div className={styles.deal_card}>
            <div className={styles.deal_row}>
              <span className={styles.deal_key}>ID сделки:</span>
              <span className={styles.deal_val}>{offer.id}</span>
            </div>
            <div className={styles.deal_row}>
              <span className={styles.deal_key}>Сумма:</span>
              <span className={styles.deal_val}>
                {offer.amountFiat} {offer.fiatCode}
              </span>
            </div>
            <div className={styles.deal_row}>
              <span className={styles.deal_key}>Тип:</span>
              <span className={styles.deal_val}>P2P обмен</span>
            </div>
          </div>
          <p className={styles.safe_caption}>
            Номер карты получателя и реквизиты оплаты в этом окне не показываем.
          </p>
        </div>

        <div className={styles.danger_card}>
          <p>
            <strong>Предупреждение:</strong> если записать или отправить это
            фото/видео вас попросил другой человек, не делайте этого и прекратите
            перевод. Такое фото/видео может быть использовано для обмана и
            безвозвратной потери средств.
          </p>
        </div>
      </div>

      {/* Прибитый footer: подтверждение + действия всегда на виду. */}
      <div className={styles.footer}>
        <label className={styles.confirm_card}>
          <input type="checkbox" checked disabled readOnly />
          <div>
            <p className={styles.confirm_title}>
              Я подтверждаю, что выполняю перевод{" "}
              <strong>самостоятельно, добровольно и без указаний со стороны третьих лиц.</strong>
            </p>
          </div>
        </label>

        <div className={styles.actions}>
          <Button
            content="Загрузить фото"
            variant="primary"
            onClick={onUpload}
          />
          <Button
            content="Вернуться к заявке"
            variant="hollow"
            onClick={onClose}
          />
        </div>
      </div>
    </Modal>
  );
};
